import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoaderService } from '../core/page-loader.service';

@Component({
  selector: 'app-election-not-found',
  imports: [CommonModule],
  templateUrl: './election-not-found.component.html',
  styleUrl: './election-not-found.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectionNotFoundComponent implements OnInit {
  constructor(private readonly pageLoaderService: PageLoaderService) {}

  ngOnInit(): void {
    this.pageLoaderService.hide();
  }
}
